export enum MessageChannel {
  Route = 'Route',
  Confirmation = 'Confirmation',
  Location = 'Location',
  SubjectId = 'SubjectId',
  UpdateSubjects = 'UpdateSubjects',
  Toast = 'Toast',
}

